import { Controller } from "stimulus";
import toastr from 'toastr';

export default class extends Controller {
  static targets = [
    'input',
    'content'
  ];

  focus() {
    this.contentTarget.classList.add("show-tooltip");
  }

  blur() {
    this.contentTarget.classList.remove("show-tooltip");
  }

  connect() {
    this.inputTarget.autocomplete = "off";

    this.inputTarget.addEventListener("focus", this.focus.bind(this))
    this.inputTarget.addEventListener("blur", this.blur.bind(this))
  }
}
